module.exports = __webpack_public_path__ + "static/media/training.41715bce.webp";